/**
 * After `refreshAccessToken` fails (missing/invalid refresh cookie), Apollo must not
 * retry that mutation on every subsequent 401 — that hammers the API and confuses users.
 * Mark the session as dead until explicit recovery (login, successful refresh, logout,
 * or a new Apollo client for a different GraphQL URL).
 */
let authSessionRefreshDead = false;

export function markAuthSessionRefreshDead(): void {
  authSessionRefreshDead = true;
}

export function resetAuthSessionRefreshCircuit(): void {
  authSessionRefreshDead = false;
}

export function isAuthSessionRefreshDead(): boolean {
  return authSessionRefreshDead;
}
